<template>
    <v-card class="soli-round" style="overflow: hidden" :ripple="true">
        <div
            class="soli-round"
            @click="selectStat(stat, $event)"
            :class="selected ? 'selected' : null"
            style="cursor: pointer"
        >
            <div :class="stat.color" class="pa-2">
                <div
                    class="white--text flex justify-center subtitle-2"
                    :class="caption ? 'caption' : null"
                >
                    {{ showMonth ? globalMomentMonthFull() : "Current" }}
                </div>
                <div
                    class="white--text flex justify-center whitespace-no-wrap subtitle-2"
                    :class="caption ? 'caption' : null"
                >
                    {{ stat.title }}
                </div>
            </div>
            <v-card-title
                class="py-3 soli-grey justify-center"
                v-if="stat.value || stat.value === 0"
            >
                {{ `${stat.value}${percent ? "%" : ""}` }}
            </v-card-title>
            <v-skeleton-loader
                v-if="!stat.value && stat.value !== 0"
                class="mx-auto"
                max-width="300"
                type="list-item"
            ></v-skeleton-loader>
        </div>
    </v-card>
</template>

<script>
import globalMoment from "../../Mixins/GlobalMoment.js";

export default {
    mixins: [globalMoment],
    props: {
        value: {
            type: Number,
        },
        title: {
            type: String,
        },
        color: {
            type: String,
        },
        link: {
            type: String,
        },
        showMonth: {
            type: Boolean,
            default: false,
        },
        selected: {
            type: Boolean,
            default: false,
        },
        percent: {
            type: Boolean,
            default: false,
        },
        caption: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        stat() {
            return {
                value: this.value,
                title: this.title,
                color: this.color,
                link: this.link,
            };
        },
    },
    methods: {
        selectStat(stat, event) {
            if (stat.link) this.$inertia.visit(stat.link);
            this.$emit("click", stat);
            if (this.selected) {
                event.target.blur();
                event.target.parentElement.blur();
                event.target.parentElement.parentElement.blur();
            }
        },
    },
};
</script>

<style #scoped>
.selected {
    background-color: rgba(0, 0, 0, 0.1) !important;
}
</style>
